import { render, staticRenderFns } from "./PowerDialog.vue?vue&type=template&id=8f40fad6"
import script from "./PowerDialog.vue?vue&type=script&lang=ts"
export * from "./PowerDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports